import React from 'react'
import { ListGroup, Card } from 'react-bootstrap'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faSpinner } from '@fortawesome/free-solid-svg-icons'
import PropTypes from 'prop-types'


export default function SelectedRowsInList(props) {
  return (
    <ListGroup {...props} variant="flush">
      {props.selectedRows.map(item => (
        <ListGroup.Item key={item.key}>
          <Card border="primary">
            <Card.Header>
              <span>{props.loading ? <span><FontAwesomeIcon icon={faSpinner} pulse/>&nbsp;</span> : '' }</span>
              <span>{item.name}</span>
            </Card.Header>
            <Card.Body>
              <Card.Text>
                <small>{item.title ? 'Title ' + item.title : ''}</small>
                <br></br>
                <small>{item.useForPreview ? 'Used for Preview' : ''}</small>
              </Card.Text>
            </Card.Body>
          </Card>
        </ListGroup.Item>
      ))}
    </ListGroup>

  )
}

SelectedRowsInList.propTypes = {
  itemId: PropTypes.string,
  loading: PropTypes.bool,
  selectedRows: PropTypes.array
}
